/**
 * Calendar
 */





/**
 * Foundation init
 */
$(document).foundation();

$.fn.fdatepicker.dates['pl'] = {
    days: ["Niedziela", "Poniedziałek", "Wtorek", "Środa", "Czwartek", "Piątek", "Sobota", "Niedziela"],
    daysShort: ["Nie", "Pn", "Wt", "Śr", "Czw", "Pt", "So", "Nie"],
    daysMin: ["N", "Pn", "Wt", "Śr", "Cz", "Pt", "So", "N"],
    months: ["Styczeń", "Luty", "Marzec", "Kwiecień", "Maj", "Czerwiec", "Lipiec", "Sierpień", "Wrzesień", "Październik", "Listopad", "Grudzień"],
    monthsShort: ["Sty", "Lu", "Mar", "Kw", "Maj", "Cze", "Lip", "Sie", "Wrz", "Pa", "Lis", "Gru"],
    today: "Dzisiaj",
    weekStart: 1
};
/**
 * Callout
 * Return simple formated alert
 */
$.fn.callout = function (message, type)
{
    // Alert classes
    var types = {
        success: "success",
        error: "alert",
        primary: "primary",
    }

    // Return formated callout
    return $(this).html('<div class="callout ' + types[type] + '">' + message + '</div>');
};

/**
 * Equalizer
 * Setup the same height for all selected elements
 */
$.fn.equalizer = function ()
{
    // Reset height
    $(this).css('height', 'auto');

    // Get all heights
    var elementHeights = $(this).map(function () {
        return $(this).outerHeight();
    }).get();

    // Get max height
    var maxHeight = Math.max.apply(null, elementHeights);

    // Set max height to all elements
    $(this).css('height', maxHeight);
};
//cookies

$('.cookieBar').cookieBar({closeButton: '.accept_button'});




/**
 * Contact form
 */
$('form.contact').on('submit', function (event)
{
    // Prevent submit form as default method
    event.preventDefault();

    // Helper
    var self = this;

    // Button
    var response = $(this).find('.response');
    var button = $(this).find('.button');

    // Add loader
    button.attr('data-loading', '');

    // Ajax submit
    $.ajax({
        type: "POST",
        url: ajax_url + "contact",
        data: $(self).serialize(),
        dataType: "json",
        success: function (data) {

            // Remove loader
            button.removeAttr('data-loading');

            // Response
            if (data.success) {

                // Set success
                response.callout(data.message, 'success');

                // Clear fields
                $(self).find('input[name!="security"], textarea').val('');
            } else {

                // Set error
                response.callout(data.message, 'error');
            }
            ;
        },
        error: function (data) {
            // Set error
            response.callout(data.responseText, 'error');
        }
    });
});

/**
 * Register form
 */
$('form.register__content').on('submit', function (event)
{
    // Prevent submit form as default method
    event.preventDefault();

    // Helper
    var self = this;

    // Button
    var response = $(this).find('.response');
    var button = $(this).find('.button');

    // Add loader
    button.attr('data-loading', '');

    // Ajax submit
    $.ajax({
        type: "POST",
        url: ajax_url + "register",
        data: $(self).serialize(),
        dataType: "json",
        success: function (data) {
            console.log(data);
            // Remove loader
            button.removeAttr('data-loading');

            // Response
            if (data.success) {
                // Set success
                response.callout(data.message, 'success');
                // Clear fields
                $(self).find('input[name!="security"], textarea').val('');
            } else {
                // Set error
                response.callout(data.message, 'error');
            }

            $(".reveal-overlay").animate({
                scrollTop: 0
            }, 800);

        },
        error: function (data) {

            // Set error
            response.callout(data.responseText, 'error');
        }
    });
});

if ($("#register").length) {
    $('.subject_select').on('change', function () {
        var date = $(this).find(':selected').data("date");
//        console.log(date);
        var price = $(this).find(':selected').data("price");

        if (date) {
//            console.log(date);
            $(".training_date_li").show();

            $(".training_date").html(date);
        } else {
            console.log(date);
            $(".training_date_li").hide();
            $(".training_date").html("");
        }
        if (price) {
            $(".training_price_li").show();
            $(".training_price").html(price);
        } else {
            $(".training_price_li").hide();
            $(".training_price").html("");
        }


    });
}

/**
 * Register form
 */
$('form.newsletter').on('submit', function (event)
{
    // Prevent submit form as default method
    event.preventDefault();

    // Helper
    var self = this;

    // Button
    var response = $(this).find('.response');
    var button = $(this).find('.button');

    // Add loader
    button.attr('data-loading', '');

    // Ajax submit
    $.ajax({
        type: "POST",
        url: ajax_url + "newsletter",
        data: $(self).serialize(),
        dataType: "json",
        success: function (data) {

            // Remove loader
            button.removeAttr('data-loading');

            // Response
            if (data.success) {

                // Set success
                response.callout(data.message, 'success');

                // Clear fields
                $(self).find('input[name!="security"], textarea').val('');
                $(self).find('input[type="checkbox"]').attr("checked", false);
            } else {

                // Set error
                response.callout(data.message, 'error');
            }
            ;
        },
        error: function (data) {
            // Set error
            response.callout(data.responseText, 'error');
        }
    });
});

$('form.newsletter_sign_out').on('submit', function (event)
{
    // Prevent submit form as default method
    event.preventDefault();

    // Helper
    var self = this;

    // Button
    var response = $(this).find('.response');
    var button = $(this).find('.button');

    // Add loader
    button.attr('data-loading', '');

    // Ajax submit
    $.ajax({
        type: "POST",
        url: ajax_url + "newsletter_sign_out",
        data: $(self).serialize(),
        dataType: "json",
        success: function (data) {

            // Remove loader
            button.removeAttr('data-loading');

            // Response
            if (data.success) {

                // Set success
                response.callout(data.message, 'success');

                // Clear fields
                $(self).find('input[name!="security"], textarea').val('');

            } else {

                // Set error
                response.callout(data.message, 'error');
            }
            ;
        },
        error: function (data) {
            // Set error
            response.callout(data.responseText, 'error');
        }
    });
});

/**
 * Plain js map
 * usage: add div with id "gmap",
 * in attr data-address add addres
 * and setup height of map, thats all
 */
function maps()
{
    var geocoder = new google.maps.Geocoder();
    var map = document.getElementById('gmap');

    if (map) {
        var coord = map.getAttribute('data-address');
    }

    if (coord)
    {
        geocoder.geocode({'address': coord}, function (results, status)
        {
            if (status == google.maps.GeocoderStatus.OK)
            {

                var lat = results[0].geometry.location.lat();
                var lng = results[0].geometry.location.lng();
                var latLng = new google.maps.LatLng(lat, lng);

                var mapOptions = {
                    center: latLng,
                    scrollwheel: false,
                    zoom: 15
                };

                var map = new google.maps.Map(document.getElementById('gmap'), mapOptions);
                var marker = new google.maps.Marker({
                    position: latLng,
                    map: map,
                    icon: site_url + 'dist/img/marker.png'
                });
            }
            ;
        });
    }
}

/**
 * Dropdown menu
 */
$(window).on('load', function () {
    $('.children').before('<span class="toggle"></span>');
    $('li.current-cat-ancestor > .toggle, .current-cat > .toggle').click();
});

$(window).on('load resize', function () {
    $('.expert').equalizer();
    $('.expert img').equalizer();
    $('.expert__content').equalizer();
    $('.partners__item a').equalizer();
});

/**
 * Open dropdown
 */
$(document).on('click', '.toggle', function () {
    $(this).toggleClass('toggle--open');
});

/**
 * Lightbox
 */
lightbox.option({
    'resizeDuration': 200,
    'wrapAround': true,
    'albumLabel': "Referencja %1 / %2"
});

/**
 * Slides
 */
$('.slides').slick({
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000,
});

/**
 * Categories
 */
$('.categories__loop, .about__loop').slick({
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 300,
    slidesToShow: 6,
    slidesToScroll: 1,
    infinite: false,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 4,
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
            }
        },
    ]
});

/**
 * Partners
 */
$('.partners__loop').slick({
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 4,
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
            }
        },
    ]
});

/**
 * Burger
 */
$(window).on('load resize', function () {
    var nav = $('.main-menu');
    var item = nav.find('li:first-child');
    var header = $('.header');

    $('.main-menu').addClass('main-menu--loaded');

    header.removeClass('header--mobile');
    nav.removeClass('main-menu--mobile');

    nav.removeClass('main-menu--open');
    $('.burger').removeClass('open');

    if (nav.height() > item.height()) {
        header.addClass('header--mobile');
        nav.addClass('main-menu--mobile');
    }
});

/**
 * Open
 */
$('.burger').on('click', function () {
    $(this).toggleClass('open');
    $('.main-menu').toggleClass('main-menu--open');
});

/**
 * Multiple persons
 */
$(document).on('open.zf.reveal', function () {

    $('.person-template .person').clone(true).appendTo('#personsList');


    $(".dp").fdatepicker({
        format: 'dd-mm-yyyy',
        disableDblClickSelection: true,
        language: 'pl',
        leftArrow: '<<',
        rightArrow: '>>',
        closeIcon: 'X',
        closeButton: true
    });

});

$(document).on('change', '#personsNumber', function () {
    $('#personsList').html('');

    for (var i = $(this).val(); i >= 1; i--) {
        var $person = $('.person-template .person').clone();

        $person.find('input').each(function () {
            $(this).attr('name', $(this).attr('name').replace('0', i));
        });
        $person.appendTo('#personsList');
    }

    $(".dp").fdatepicker({
        format: 'dd-mm-yyyy',
        disableDblClickSelection: true,
        language: 'pl',
        leftArrow: '<<',
        rightArrow: '>>',
        closeIcon: 'X',
        closeButton: true
    });
});

/**
 * References
 */
$('.references-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    dots: false,
    prevArrow: false,
    nextArrow: false,
    responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: true
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }]
});
